import React from 'react';

import { IconProps } from './type';

const ArrowDownIcon: React.FC<IconProps> = ({ className = '', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M2.72027 5.94L7.06694 10.2867C7.58027 10.8 8.42027 10.8 8.93361 10.2867L13.2803 5.94"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowDownIcon;
